import { IComponent } from '@eventr/common'
import { ColoursObj } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { ComponentFinder } from '../componentFinder'
import { useScreenTypeContext } from '../state/screenTypeProvider'

interface IContainerProps {
    data: any
    renderOptions: IContainerOptions
    parentData?: any
    past?: boolean
}
interface IContainerOptions {
    components: IComponent[]
    direction?: 'row' | 'column'
    alignItems?: 'center' | 'flex-start' | 'flex-end'
    justifyContent?: 'center' | 'flex-start' | 'flex-end'
    background?: boolean
    borderRadius?: string
    padding?: string
    visible?: string[]
    maxWidth?: string
    width?: string
    gap?: string
}

export const Container = ({
    data,
    renderOptions,
    parentData,
    past,
}: IContainerProps) => {
    const { screenType } = useScreenTypeContext()
    if (renderOptions.visible && !renderOptions.visible.includes(screenType)) {
        return null
    } else {
        return (
            <>
                {data && renderOptions.components && (
                    <Stack
                        alignItems={renderOptions.alignItems ?? 'center'}
                        direction={renderOptions.direction ?? 'row'}
                        justifyContent={
                            renderOptions.justifyContent ?? 'flex-start'
                        }
                        maxWidth={renderOptions.maxWidth ?? undefined}
                        width={renderOptions.width ?? undefined}
                        gap={renderOptions.gap ?? undefined}
                        bgcolor={
                            renderOptions.background
                                ? ColoursObj.backgrounds.secondary
                                : undefined
                        }
                        borderRadius={renderOptions.borderRadius}
                        padding={renderOptions.padding}
                    >
                        {renderOptions.components.map((c, i) => {
                            return (
                                <ComponentFinder
                                    key={'finder_' + c.componentKey + i}
                                    data={data}
                                    renderOptions={c}
                                    componentKey={c.componentKey}
                                    parentData={parentData}
                                    isInPast={past}
                                />
                            )
                        })}
                    </Stack>
                )}
            </>
        )
    }
}
